import { AppInterfaceV1Type } from './types';
import AppInterfaceV1 from './AppInterfaceV1';

export { createNoopAppInterface } from './NoopInterface';

let appInterfaceV1: AppInterfaceV1;

export function getAppInterfaceV1(): AppInterfaceV1Type {
  return appInterfaceV1.getInterface();
}

export default async function initializeAppInterfaceV1(): Promise<AppInterfaceV1Type> {
  if (appInterfaceV1) return appInterfaceV1.getInterface();
  appInterfaceV1 = new AppInterfaceV1();

  return appInterfaceV1.getInterface();
}
